import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import DatePicker from 'vue2-datepicker'
import Loader from './../shared/loader'
import {
	Validator
} from 'vee-validate'
export default {
	name: 'po',
	components: {
		Paginate,
		DatePicker,
		Loader
	},
	data: function() {
		return {
			currentPage: 0,
			pageno: 0,
			pagecount: 0,
			modalMessageShowpo: false,
			successemsg: '',
			qtyError: true,
			unitprError: false,
			unitprshowerror: false,
			isActive: true,
			iserror: false,
			hasError: false,
			checkigst: false,
			checkcgst: false,
			showpoform: true,
			itemlinerror: false,
			checkgsterror: false,
			deliveybydateerror: false,
			qtyshowerror: false,
			dilverydatemsg: false,
			selecteditemerror: false,
			errors1: [],
			showclientaddress: true,
			showwarehousedata: false,
			showsupplierdata: false,
			gsttype: '',
			checkpoerrmsg: '',
			checkpoerr: false,
			sgstoptions: [{
					value: 4,
					text: '4'
				},
				{
					value: 5,
					text: '5'
				},
				{
					value: 8,
					text: '8'
				},
				{
					value: 12,
					text: '12'
				},
				{
					value: 18,
					text: '18'
				}
			],
			gstoptions: [{
					value: 4,
					text: '4'
				},
				{
					value: 5,
					text: '5'
				},
				{
					value: 8,
					text: '8'
				},
				{
					value: 12,
					text: '12'
				},
				{
					value: 18,
					text: '18'
				}
			],
			igstoptions: [{
					value: 4,
					text: '4'
				},
				{
					value: 5,
					text: '5'
				},
				{
					value: 8,
					text: '8'
				},
				{
					value: 12,
					text: '12'
				},
				{
					value: 18,
					text: '18'
				}
			],
			hsnrateoptions: [{
					value: 4,
					text: '4'
				},
				{
					value: 5,
					text: '5'
				},
				{
					value: 8,
					text: '8'
				},
				{
					value: 12,
					text: '12'
				},
				{
					value: 18,
					text: '18'
				}
			],
			supplieroptions: [],
			// initialize form field
			noofrows: 5,
			products: [],
			takenpids: {},
			taken: [],
			source: '',
			deepSource: '',
			supplierdata: '',
			supplierlist: [],
			warehouselist: [],
			warehousedata: '',
			clientdata: '',
			loginClientUserId: '',
			supplier: {
				supplierid: '',
				suppliercompanyname: '',
				supplieraddress: '',
				emailid: '',
				addressline1: '',
				addressline2: '',
				country: '',
				state: '',
				city: '',
				pincode: '',
				phonenumber: '',
				contactperson: '',
			},
			warehouse: {
				warehouseid: '',
				warehousename: '',
				warehouseaddress: '',
				warehousecity: '',
				warehousestate: '',
				warehousecountry: '',
				warehousepincode: '',
				contactno: '',
				contactpersonname: '',
				warehouseemail: '',
				gstno: '',
				totalsqft: '',
				emailid: '',
			},
			billto: {
				CompanyName: '',
				AddressLine1: '',
				AddressLine2: '',
				City: '',
				State: '',
				Country: '',
				PinCode: '',
				PhoneNumber: '',
				Email: '',
				ContactPerson: ''
			},
			poform: {
				clientid: '',
				merchantid: '',
				merchantname: '',
				warehouseid: '',
				warehousename: '',
				suppliercompanyname: '',
				pono: '',
				podate: null,
				podiscription: '',
				status: '',
				fob: '',
				paymentterms: '',
				carrier: '',
				freight: '',
				comments: '',
				termsconditions: '',
				createdby: '',
				lastmodifiedby: '',
				checkedby: '',
				authorizedby: '',
				contactperson: '',
				buyer: '',
				tax: 0,
				shippingcharges: 0,
				deliverbydate: null,
				loginwarehouseid: ''
			},
			invoice_items: [],
			searchmodalShow: false,
			searchproduct: {
				clientproductid: '',
				productname: ''
			},
			selectedpoindex: '',
			showserchproductform: true,
			searchproductloopdata: [],
			isproductloading: false,
			shownoproductfound: false,
		}
	},
	computed: {
		checkdeliverydate() {
			if (this.poform.deliverbydate !== '' && this.poform.deliverbydate !== null) {
				var sd = new Date(this.poform.deliverbydate);
				var ed = new Date();
				//This condition means the end date is bigger even if the comparison says otherwise
				//Can work without Parse
				if (Date.parse(sd) < Date.parse(ed)) {
					this.dilverydatemsg = true;
				} else {
					this.dilverydatemsg = false;
				}
				this.deliveybydateerror = false;
				this.iserror = false;
			}
		},
		itemsWithSubTotal() {
			return this.invoice_items.map(item => ({
				item,
				subtotal: this.computeSubTotal(item),
				cgstrate: this.computecgstrate(item),
				sgstrate: this.computesgstrate(item),
				igstrate: this.computeigstrate(item),
				totalincludetaxes: this.computeTotalincludetaxes(item),
			}))
		},
		total() {
			let calculatetotal = 0;
			// group the items with total
			let grouped = this.itemsWithSubTotal
			for (let i = 0; i < grouped.length; i++) {
				if (Number(this.itemsWithSubTotal[i].totalincludetaxes) != 0) {
					calculatetotal = calculatetotal + Number(this.itemsWithSubTotal[i].totalincludetaxes);
				}
			}
			return calculatetotal;
		},
		finaltotal() {
			let final_total = 0;
			final_total = Number(this.total) + Number(this.poform.shippingcharges);
			return final_total;
		},
	},

	created: function() {
		// when a page loads,mounted() will be call
	},
	mounted() {
		this.poform.podate = this.getdate();
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginwarehouseid = userdetail.warehouseid;
		this.loginClientUserId = userdetail.clientid;

		this.poform.createdby = loginuseremail,
			this.poform.lastmodifiedby = loginuseremail,
			this.poform.checkedby = loginuseremail,
			this.poform.authorizedby = loginuseremail,
			this.pageno = 0
		this.getloginclientdata(loginuserid);
		this.getwarehouselist();
		for (var x = 0; x < this.noofrows; x++) {
			this.invoice_items.push({
				productid: "",
				clientproductid: "",
				productname: "",
				productdescription: "",
				unitprice: '',
				quantity: '',
				hsncode: '',
				hsnrate: '',
				uom: '',
				mrp: '',
				cgst: '',
				sgst: '',
				igst: '',
				gst: '',
				discount: '',
				cgstrate: '',
				sgstrate: '',
				igstrate: '',
				isactive: '',
				productcategory: '',
				brand: '',
				unitlength: '',
				unitbreadth: '',
				unitheight: '',
				mrpshowerror: false,
			});
		}
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		addRow: function() {
			this.invoice_items.push({
				productid: "",
				clientproductid: "",
				productname: "",
				productdescription: "",
				unitprice: '',
				quantity: '',
				hsncode: '',
				hsnrate: '',
				uom: '',
				mrp: '',
				cgst: '',
				sgst: '',
				igst: '',
				gst: '',
				discount: '',
				cgstrate: '',
				sgstrate: '',
				igstrate: '',
				isactive: '',
				productcategory: '',
				brand: '',
				unitlength: '',
				unitbreadth: '',
				unitheight: '',
				mrpshowerror: false,
			})
		},
		sourceChanged: function(e) {
			if (this.selecteditemerror) {
				this.productalredayaddederrror = true;
				var selectedInd = e.target.getAttribute('ind');
				var alertmsg = "Duplicate Product Please Change Product or Unit Price"
				this.$alertify.error(alertmsg);
				this.invoice_items[selectedInd].productname = '';
				return false;
			}
			if (this.checkcgst || this.checkigst) {
				this.itemlinerror = false;
				var selectedInd = e.target.getAttribute('ind');
				var newSource = e.target.value;
				if (selectedInd > 0 && this.qtyError == true) {
					this.qtyshowerror = true;
					this.$alertify.error("Please Add Quantity");
					this.invoice_items[selectedInd].productname = '';
					return false;
				}
				if (selectedInd > 0 && this.unitprError == true) {
					this.unitprshowerror = true;
					this.$alertify.error("Please Add PTR");
					this.invoice_items[selectedInd].productname = '';
					return false;
				}

				for (var i = 0; i < this.products.length; i++) {
					if (this.products[i].productname == newSource) {
						this.deepSource = this.products[i];
						this.invoice_items[selectedInd].productname = this.deepSource.productname;
						this.invoice_items[selectedInd].productdescription = this.deepSource.productdescription;
						this.invoice_items[selectedInd].hsncode = this.deepSource.hsncode;
						if (this.checkigst) {
							this.invoice_items[selectedInd].igst = this.deepSource.hsnrate;
						} else {
							this.invoice_items[selectedInd].gst = this.deepSource.hsnrate;
						}
						this.invoice_items[selectedInd].productid = this.deepSource.productid;
						this.invoice_items[selectedInd].clientproductid = this.deepSource.clientproductid;
						this.invoice_items[selectedInd].isactive = this.deepSource.isactive;
						this.invoice_items[selectedInd].productcategory = this.deepSource.productcategory;
						this.invoice_items[selectedInd].brand = this.deepSource.brand;
						this.invoice_items[selectedInd].unitlength = this.deepSource.unitlength;
						this.invoice_items[selectedInd].unitbreadth = this.deepSource.unitbreadth;
						this.invoice_items[selectedInd].unitheight = this.deepSource.unitheight;
						this.invoice_items[selectedInd].unitprice = '';
						this.invoice_items[selectedInd].discount = 0;
						this.invoice_items[selectedInd].uom = this.deepSource.primaryuom;
						this.invoice_items[selectedInd].mrp = this.deepSource.mrp;
						this.invoice_items[selectedInd].quantity = '';

						if (this.checkcgst) {
							this.invoice_items[selectedInd].gst = this.deepSource.hsnrate;
							//  this.invoice_items[selectedInd].sgst=this.deepSource.sgst;
							this.invoice_items[selectedInd].igst = 0;
						} else {
							this.invoice_items[selectedInd].cgst = 0;
							this.invoice_items[selectedInd].sgst = 0;
							this.invoice_items[selectedInd].igst = this.deepSource.hsnrate;
						}
						this.qtyError = true;
						this.unitprError = true;
						document.getElementById(selectedInd).focus();
					}
				}
				this.taken.push({
					clientproductid: this.invoice_items[selectedInd].clientproductid,
					unitprice: this.invoice_items[selectedInd].unitprice
				});
				this.$emit('sourceChanged', this.deepSource.id);
			} else {
				this.checkgsterror = true;
				var selectedInd = e.target.getAttribute('ind');
				this.invoice_items[selectedInd].productname = '';
			}
		},
		setgstrates(index) {
			this.invoice_items[index].cgst = (this.invoice_items[index].gst / 2);
			this.invoice_items[index].sgst = (this.invoice_items[index].gst / 2);
		},
		checkproductadded: function(e) {
			var countp = 0;
			var selecteditems1 = this.getinvoice_items();
			let selectedrows = selecteditems1;
			var selectedInd1 = e.target.getAttribute('ind1');
			if (this.invoice_items[selectedInd1].unitprice == '') {
				this.$alertify.error("Please Enter Unitprice");
				this.unitprError = true;
			} else {
				this.unitprError = false;
				this.unitprshowerror = false;
			}
		},
		checkproductalreadyadded(index) {
			var countp = 0;
			var selecteditems1 = this.getinvoice_items();
			let selectedrows = selecteditems1;
			for (var x = 0; x < selecteditems1.length; x++) {
				if (selecteditems1[x].item.clientproductid == this.invoice_items[index].clientproductid && selecteditems1[x].item.mrp == this.invoice_items[index].mrp) {
					this.selecteditemerror = true;
					countp++;
				}
			}
			if (this.invoice_items[index].unitprice == '') {
				if (countp > 0) {
					this.selecteditemerror = true;
					this.invoice_items[index].mrpshowerror = true;
					this.selcteditemerrormsg = "Item with " + this.invoice_items[index].productname + " Already Added";
					return true;
				} else {
					this.invoice_items[index].mrpshowerror = false;
					this.selecteditemerror = false;
					this.selcteditemerrormsg = '';
					this.mrpshowerror = true;
					return false;
				}
			} else {
				if (countp > 1) {
					this.selecteditemerror = true;
					this.invoice_items[index].mrpshowerror = true;
					this.selcteditemerrormsg = "Item with " + this.invoice_items[index].productname + " Already Added";
					return true;
				} else {
					this.invoice_items[index].mrpshowerror = false;
					this.selecteditemerror = false;
					this.selcteditemerrormsg = '';
					this.mrpshowerror = true;
					return false;
				}
			}
		},
		checkqty(qty) {
			if (qty == '' || qty < 1) {
				this.$alertify.error("Please Add Quantity");
				this.qtyError = true;
			} else {
				this.qtyError = false;
				this.unitprshowerror = false;
			}
		},
		getProducts: function(e) {
			if (this.checkcgst || this.checkigst) {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				var txt = encodeURIComponent(e.target.value.trim());
				this.input = ({});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getProduct/' + txt,
						'data': {
							clientid: this.clientdata.clientid,
							supplierid: this.supplier.supplierid,
							warehouseid: this.poform.warehouseid
						},
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						var selectedproductarry = this.taken;
						if (selectedproductarry.length > 0) {
							for (var i = 0; i < selectedproductarry.length; i++) {
								result.data = result.data.filter(function(emp) {
									return emp.clientproductid != selectedproductarry[i]
								});
							}
						}
						this.products = result.data;
					}, error => {
						console.error(error);
					})
			} else {
				this.checkgsterror = true;
				var selectedInd = e.target.getAttribute('ind');
				this.invoice_items[selectedInd].productname = '';
			}
		},
		supplierChanged: function(e) {
			this.iserror = false;
			var newsupplier = e.target.value;
			if (newsupplier != this.supplierdata.merchantname) {
				for (var i = 0; i < this.supplierlist.length; i++) {
					if (this.supplierlist[i].merchantname == newsupplier) {
						this.supplierdata = this.supplierlist[i];
						this.supplier.supplierid = this.supplierdata.merchantid;
						this.supplier.suppliercompanyname = this.supplierdata.merchantname;
						this.supplier.addressline1 = this.supplierdata.merchantaddress;
						this.supplier.addressline2 = this.supplierdata.merchantaddress2;
						this.supplier.supplieraddress = this.supplierdata.merchantaddress;
						this.supplier.city = this.supplierdata.city;
						this.supplier.state = this.supplierdata.state;
						this.supplier.country = this.supplierdata.country;
						this.supplier.pincode = this.supplierdata.pincode;
						this.supplier.phonenumber = this.supplierdata.merchantpersonmobile;
						this.supplier.emailid = this.supplierdata.merchantpersonemail;
						this.supplier.contactperson = this.supplierdata.merchantpersonname;
						this.showsupplierdata = true;
					}
				}
				this.checkstate();
				this.$emit('merchantidChanged', this.supplierdata.id);
			}
		},
		checkstate() {
			if (this.warehouse.warehousestate != '' && this.supplier.state != '') {
				if (this.warehouse.warehousestate == this.supplier.state) {
					this.checkcgst = true;
					this.checkigst = false;
					this.gsttype = "sgst,cgst";
					this.checkgsterror = false;
				} else {
					this.checkcgst = false;
					this.checkigst = true;
					this.gsttype = "igst";
					this.checkgsterror = false;
				}
			}
		},
		checkpo: function(e) {
			var pono = this.poform.pono;
			axios.post(apiUrl.api_url + 'checkpo', {
					'pono': pono,
				})
				.then((response) => {
					if (response.data.length > 0) {
						this.checkpoerr = true;
						this.checkpoerrmsg = "Pono Already Exists."
					} else {
						this.checkpoerr = false;
						this.checkpoerrmsg = ""
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		checkpo1: function(e) {
			this.checkpoerrmsg = ""
		},
		warehouseChanged: function(e) {
			this.iserror = false;
			var newwarehouse = e.target.value;
			if (newwarehouse != this.warehousedata.warehousename) {
				for (var i = 0; i < this.warehouselist.length; i++) {
					if (this.warehouselist[i].warehousename == newwarehouse) {
						this.warehousedata = this.warehouselist[i];
						this.poform.warehouseid = this.warehousedata.warehouseid;
						this.warehouse.warehousename = this.warehousedata.warehousename;
						this.warehouse.warehouseaddress = this.warehousedata.warehouseaddress;
						this.warehouse.warehousecity = this.warehousedata.warehousecity;
						this.warehouse.warehousestate = this.warehousedata.warehousestate;
						this.warehouse.warehousecountry = this.warehousedata.warehousecountry;
						this.warehouse.warehousepincode = this.warehousedata.warehousepincode;
						this.warehouse.contactno = this.warehousedata.contactno;
						this.warehouse.contactpersonname = this.warehousedata.contactpersonname
						this.warehouse.emailid = this.warehousedata.warehouseemail;
						this.showwarehousedata = true;
					}
				}
				this.checkstate();
				this.$emit('merchantidChanged', this.warehousedata.id);
			}
		},
		computeSubTotal: function(invoice_item) {
			var discount = (invoice_item.unitprice * (invoice_item.discount / 100)) * invoice_item.quantity;
			return (invoice_item.unitprice * invoice_item.quantity) - discount;
		},
		computecgstrate: function(invoice_item) {
			var discount = (invoice_item.unitprice * (invoice_item.discount / 100)) * invoice_item.quantity;
			return Number(((invoice_item.unitprice * invoice_item.quantity) - discount) * (invoice_item.cgst / 100)).toFixed(2);
		},
		computesgstrate: function(invoice_item) {
			var discount = (invoice_item.unitprice * (invoice_item.discount / 100)) * invoice_item.quantity;
			return Number(((invoice_item.unitprice * invoice_item.quantity) - discount) * (invoice_item.sgst / 100)).toFixed(2);
		},
		computeigstrate: function(invoice_item) {
			var discount = (invoice_item.unitprice * (invoice_item.discount / 100)) * invoice_item.quantity;
			return Number(((invoice_item.unitprice * invoice_item.quantity) - discount) * (invoice_item.igst / 100)).toFixed(2);
		},
		computeTotalincludetaxes: function(invoice_item) {
			var discount = (invoice_item.unitprice * (invoice_item.discount / 100)) * invoice_item.quantity;
			var cgst = (invoice_item.cgst == '') ? 0 : invoice_item.cgst;
			var sgst = (invoice_item.sgst == '') ? 0 : invoice_item.sgst;
			var igst = (invoice_item.igst == '') ? 0 : invoice_item.igst;
			var gst = (invoice_item.gst == '') ? 0 : invoice_item.gst;
			if (igst > 0) {
				cgst = 0;
				sgst = 0;
			}
			if (cgst > 0) {
				igst = 0;
			}

			return Number(((invoice_item.unitprice * invoice_item.quantity) - discount) + (((cgst + sgst + igst) * ((invoice_item.unitprice * invoice_item.quantity) - discount)) / 100)).toFixed(2);
		},
		getsupplierlist(clientid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'MerchantListByclient',
					'data': {
						clientid: clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.supplierlist = result.data.result
				}, error => {
					console.error(error)
				});
		},
		getwarehouselist() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'clientid': this.loginClientUserId
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientWarehouseListForPO',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.warehouselist = result.data.rows
				}, error => {
					console.error(error)
				})
		},
		getloginclientdata(loginuserid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'loginuserid': this.loginClientUserId,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'Getloginclientdata',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})

				.then((response) => {
					if (response.data) {
						this.clientdata = response.data
						this.poform.clientid = this.clientdata.clientid;
						this.billto.CompanyName = this.clientdata.clientname
						this.billto.AddressLine1 = this.clientdata.clientaddress
						this.billto.AddressLine2 = this.clientdata.clientaddress2
						this.billto.City = this.clientdata.city
						this.billto.State = this.clientdata.state
						this.billto.Country = this.clientdata.country
						this.billto.PinCode = this.clientdata.pincode
						this.billto.PhoneNumber = this.clientdata.clientpersonmobile
						this.billto.Email = (this.clientdata.clientpersonemail == null) ? '' : this.clientdata.clientpersonemail
						this.billto.ContactPerson = (this.clientdata.clientpersonname == null) ? '' : this.clientdata.clientpersonname
						var random_number = Date.now();
						var ponounique = Math.round(this.poform.clientid + "" + (random_number / 1000));
						this.poform.pono = ponounique.toString();
						this.poform.buyer = this.billto.CompanyName
						this.getsupplierlist(this.poform.clientid);
					} else {
						this.checkpoerr = false;
						this.checkpoerrmsg = ""
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getinvoice_items() {
			return this.itemsWithSubTotal.filter(v => v.subtotal != 0);
		},
		getinvoice_items1() {
			var selected_items = [];
			for (var i = 0; i <= this.invoice_items.length; i++) {
				var subtotal1 = this.invoice_items[i].clientproductid;

				if (subtotal1 != '') {
					selected_items.push(this.invoice_items[i]);
				}
			}
			return selected_items;
		},
		submitinvoice(e) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var gettotalitems = this.getinvoice_items();
			var orderdetails = [];
			var SupplierAddress = {
				"AddressLine1": this.supplier.supplieraddress,
				"City": this.supplier.city,
				"State": this.supplier.state,
				"Country": this.supplier.country,
				"PinCode": this.supplier.pincode,
				"PhoneNumber": this.supplier.phonenumber,
				"Email": this.supplier.emailid,
				"ContactPerson": this.supplier.contactperson
			};
			var Billto = this.billto;
			var Shipto = {
				"CompanyName": this.warehouse.warehousename,
				"AddressLine1": this.warehouse.warehouseaddress,
				"AddressLine2": '',
				"City": this.warehouse.warehousecity,
				"State": this.warehouse.warehousestate,
				"Country": this.warehouse.warehousecountry,
				"PinCode": this.warehouse.warehousepincode.toString(),
				"PhoneNumber": (this.warehouse.contactno == null) ? 0 : this.warehouse.contactno.toString(),
				"Email": (this.warehouse.emailid == null) ? '' : this.warehouse.emailid,
				"ContactPerson": (this.warehouse.contactpersonname == null) ? '' : this.warehouse.contactpersonname
			};
			var POTerms = {
				"Freight": this.poform.freight,
				"FOB": this.poform.fob,
				"Carrier": this.poform.carrier,
				"DeliverByDate": this.poform.deliverbydate,
				"contactperson": this.supplier.contactperson,
				"paymentterms": this.poform.paymentterms,
				"buyer": this.poform.buyer,
				"podescription": this.poform.podescription,
				"shippingcharges": (this.poform.shippingcharges) == '' ? 0 : this.poform.shippingcharges,
				"createdby": this.poform.createdby
			};


			for (var i = 0; i < gettotalitems.length; i++) {
				if (gettotalitems[i].item.hsncode == "" || gettotalitems[i].item.hsncode == null) {
					gettotalitems[i].item.hsncode = "NA";
				}
				if (gettotalitems[i].item.mrp == "") {
					gettotalitems[i].item.mrp = 0;
				}
				if (gettotalitems[i].item.mrpshowerror == true) {
					var alertmsg = "Duplicate Product Found Please Change Product or MRP"
					this.$alertify.error(alertmsg)
					return false;
				}
				if (this.checkcgst) {
					var cgst = (gettotalitems[i].item.cgst == '') ? 0 : gettotalitems[i].item.cgst;
					var sgst = (gettotalitems[i].item.sgst == '') ? 0 : gettotalitems[i].item.sgst;
					var igst = 0
				} else if (this.checkigst) {
					var cgst = 0;
					var sgst = 0;
					var igst = (gettotalitems[i].item.igst == '' || gettotalitems[i].item.igst == null) ? 0 : gettotalitems[i].item.igst;
				} else {
					var cgst = 0;
					var sgst = 0;
					var igst = 0;
				}
				var CGSTAmount = (cgst / 100) * (gettotalitems[i].subtotal);
				var SGSTAmount = (sgst / 100) * (gettotalitems[i].subtotal);
				var IGSTAmount = (igst / 100) * (gettotalitems[i].subtotal);
				var Totaltaxamount = CGSTAmount + SGSTAmount + IGSTAmount;
				var unitlength = (gettotalitems[i].item.unitlength == '' || gettotalitems[i].item.unitlength == null) ? 0 : gettotalitems[i].item.unitlength;
				orderdetails.push({
					"LineNo": (i + 1).toString(),
					"Clientproductid": gettotalitems[i].item.clientproductid,
					"Productname": gettotalitems[i].item.productname,
					"ProductId": gettotalitems[i].item.productid,
					"ProductQty": gettotalitems[i].item.quantity,
					"ProductUnitsofMeasure": gettotalitems[i].item.uom,
					"ProductUnitPrice": gettotalitems[i].item.unitprice,
					"Discount": gettotalitems[i].item.discount == '' ? 0 : gettotalitems[i].item.discount,
					"ProductMRP": gettotalitems[i].item.mrp,
					"TotalPricewithouttaxes": gettotalitems[i].subtotal,
					"ProductHSNCode": gettotalitems[i].item.hsncode.toString(),
					"hsnrate": cgst + sgst + igst,
					"CGSTRatePercent": cgst == null ? 0 : cgst,
					"SGSTRatePercent": sgst == null ? 0 : sgst,
					"IGSTRatePercent": igst == null ? 0 : igst,
					"CGSTAmount": CGSTAmount,
					"SGSTAmount": CGSTAmount,
					"IGSTAmount": IGSTAmount,
					"Totaltaxamount": Totaltaxamount,
					"TotalPricewithtax": (gettotalitems[i].subtotal + Totaltaxamount)
				});
			}
			var purchaseordermaster = {
				"PurchaseOrderNumber": this.poform.pono,
				"PODate": this.getdate1(this.poform.podate),
				"SupplierCompanyName": this.supplier.suppliercompanyname,
				"ClientID": this.poform.clientid,
				"MerchantID": 0,
				"WarehouseID": this.poform.warehouseid,
				"SupplierID": this.supplier.supplierid,
				"comments": this.poform.comments,
				"SupplierAddress": SupplierAddress,
				"BillTo": Billto,
				"ShipTo": Shipto,
				"POTerms": POTerms,
				"LineItems": orderdetails
			};
			if (this.supplier.suppliercompanyname !== '' && this.poform.warehouseid != '') {
				var sd = new Date(this.poform.deliverbydate);
				var ed = new Date();
				if (this.poform.deliverbydate !== '' && this.poform.deliverbydate !== null && (Date.parse(sd) > Date.parse(ed))) {
					if (orderdetails.length > 0) {
						axios.post(apiUrl.api_url + 'pushPurchaseOrder', {
								"PurchaseOrderNumber": this.poform.pono,
								"PODate": this.getdate1(this.poform.podate),
								"SupplierCompanyName": this.supplier.suppliercompanyname,
								"ClientID": this.poform.clientid,
								"MerchantID": 0,
								"WarehouseID": this.poform.warehouseid,
								"SupplierID": this.supplier.supplierid,
								"comments": this.poform.comments,
								"SupplierAddress": SupplierAddress,
								"BillTo": Billto,
								"ShipTo": Shipto,
								"POTerms": POTerms,
								"LineItems": orderdetails
							}, {
								headers: {
									'Authorization': 'Bearer ' + myStr
								}
							})
							.then((response) => {
								if (response.data.statusCode == 200) {
									this.input = ({
										pono: response.data.pono,
										clientid: this.poform.clientid
									})
									axios({
											method: 'POST',
											'url': apiUrl.api_url + 'elspo',
											'data': this.input,
											headers: {
												'Authorization': 'Bearer ' + myStr
											}
										});

									this.resetForm();
									this.poform.podate = this.getdate();
									this.iserror = false;
									this.itemlinerror = false;
									this.modalMessageShowpo = true;
									this.successemsg = response.data.message;

								}
							})
							.catch((httpException) => {
								console.error('exception is:::::::::', httpException)
							})
					} else {
						this.itemlinerror = true;
					}
				} else {
					this.deliveybydateerror = true;
					this.iserror = true;
				}
			} else {
				this.iserror = true;
			}
		},
		getdate() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = '0' + dd;
			}
			if (mm < 10) {
				mm = '0' + mm;
			}
			var today = yyyy + '-' + mm + '-' + dd;
			return today;
		},
		getdate1(date) {
			var today = new Date(date);
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();
			if (dd < 10) {
				dd = '0' + dd;
			}
			if (mm < 10) {
				mm = '0' + mm;
			}
			var today = dd + '-' + mm + '-' + yyyy;
			return today;
		},
		deleterow(index, dindex) {
			var index1 = this.invoice_items.findIndex(x => (x.clientproductid == index.item.clientproductid && x.mrp == index.item.mrp));
			this.invoice_items.splice(dindex, 1);
			this.unitprError = false;
			this.qtyError = false;
			this.selecteditemerror = false;
		},
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		getScore(val) {
			return parseFloat(val).toFixed(2);
		},
		gotolisting() {
			this.modalMessageShowpo = false;
		},
		resetForm() {
			var self = this; //you need this because *this* will refer to Object.keys below`
			Object.keys(this.poform).forEach(function(key, index) {
				self.poform[key] = '';
			});
			for (var i = 0; i < this.invoice_items.length; i++) {
				Object.keys(this.invoice_items[i]).forEach(function(key, index) {
					self.invoice_items[i][key] = '';
				});
			}
			Object.keys(this.warehouse).forEach(function(key, index) {
				self.warehouse[key] = '';
			});
			Object.keys(this.billto).forEach(function(key, index) {
				self.billto[key] = '';
			});
			Object.keys(this.supplier).forEach(function(key, index) {
				self.supplier[key] = '';
			});
			var permissionEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			var loginuserid = userdetail.userid;
			this.getloginclientdata(loginuserid);
			this.supplierdata = '';
			this.warehousedata = '';
			this.showsupplierdata = false;
			this.showwarehousedata = false;
			this.showpoform = false;
			this.checkcgst = false;
			this.checkigst = false;
			this.poform.podate = this.getdate();
			this.$nextTick(() => {
				this.showpoform = true
			});
		},
		searchproducts(index) {
			if (this.checkcgst || this.checkigst) {
				if (index > 0 && this.qtyError == true) {
					this.qtyshowerror = true;
					this.$alertify.error("Please Add Quantity");
					this.invoice_items[index].productname = '';
					return false;
				}
				if (index > 0 && this.unitprError == true) {
					this.unitprshowerror = true;
					this.$alertify.error("Please Add PTR");
					this.invoice_items[index].productname = '';
					return false;
				}
				var self = this; //you need this because *this* will refer to Object.keys below`
				Object.keys(this.searchproduct).forEach(function(key, index) {
					self.searchproduct[key] = '';
				});
				this.searchproductloopdata = [];
				this.showserchproductform = false;
				this.$nextTick(() => {
					this.showserchproductform = true
				});
				this.selectedpoindex = index;
				this.searchmodalShow = true;
				this.shownoproductfound = false;
			} else {
				this.checkgsterror = true;
			}
		},
		searchproductsdata(data) {
			if (data == 1) {
				this.pageno = 0;
			}
			if (this.searchproduct.clientproductid == '' && this.searchproduct.productname == '') {
				this.searchproductloopdata = [];
				return false;
			} else if (this.searchproduct.productname != '' && this.searchproduct.productname.length < 3) {
				this.searchproductloopdata = [];
				this.$alertify.error("Add Atleast 3 characters in Productname search field");
				return false;
			}

			if (this.checkcgst || this.checkigst) {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({})
				this.isproductloading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getsearchProductData/',
						'data': {
							offset: this.pageno,
							limit: 10,
							clientid: this.clientdata.clientid,
							supplierid: this.supplier.supplierid,
							clientproductid: this.searchproduct.clientproductid.toString(),
							productname: this.searchproduct.productname,
							warehouseid: this.poform.warehouseid
						},
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.isproductloading = false;
						if (result.data.count > 0) {
							this.searchproductloopdata = result.data.rows;
							let totalRows = result.data.count;
							if (totalRows < 10) {
								this.pagecount = 1
							} else {
								this.pagecount = Math.ceil(totalRows / 10)
							}
							this.shownoproductfound = false;
						} else {
							this.shownoproductfound = true;
							this.searchproductloopdata = [];
						}
					}, error => {
						console.error(error);
					})
			} else {

			}

		},
		setproductline(productid) {
			var selectedInd = this.selectedpoindex
			for (var i = 0; i < this.searchproductloopdata.length; i++) {
				if (this.searchproductloopdata[i].productid == productid) {
					this.invoice_items[selectedInd].productname = this.searchproductloopdata[i].productname;
					this.invoice_items[selectedInd].productdescription = this.searchproductloopdata[i].productdescription;
					this.invoice_items[selectedInd].hsncode = this.searchproductloopdata[i].hsncode;
					if (this.checkigst) {
						this.invoice_items[selectedInd].igst = this.searchproductloopdata[i].hsnrate;
					} else {
						this.invoice_items[selectedInd].gst = this.searchproductloopdata[i].hsnrate;
					}
					this.invoice_items[selectedInd].productid = this.searchproductloopdata[i].productid;
					this.invoice_items[selectedInd].clientproductid = this.searchproductloopdata[i].clientproductid;
					this.invoice_items[selectedInd].isactive = this.searchproductloopdata[i].isactive;
					this.invoice_items[selectedInd].productcategory = this.searchproductloopdata[i].productcategory;
					this.invoice_items[selectedInd].brand = this.searchproductloopdata[i].brand;
					this.invoice_items[selectedInd].unitlength = this.searchproductloopdata[i].unitlength;
					this.invoice_items[selectedInd].unitbreadth = this.searchproductloopdata[i].unitbreadth;
					this.invoice_items[selectedInd].unitheight = this.searchproductloopdata[i].unitheight;
					this.invoice_items[selectedInd].unitprice = '';
					this.invoice_items[selectedInd].discount = 0;
					this.invoice_items[selectedInd].uom = this.searchproductloopdata[i].primaryuom;
					this.invoice_items[selectedInd].mrp = this.searchproductloopdata[i].mrp;
					this.invoice_items[selectedInd].quantity = '';

					if (this.checkproductalreadyadded(selectedInd)) {};
					if (this.checkcgst) {
						this.invoice_items[selectedInd].gst = this.searchproductloopdata[i].hsnrate;
						//  this.invoice_items[selectedInd].sgst=this.deepSource.sgst;
						this.invoice_items[selectedInd].igst = 0;
					} else {
						this.invoice_items[selectedInd].cgst = 0;
						this.invoice_items[selectedInd].sgst = 0;
						this.invoice_items[selectedInd].igst = this.searchproductloopdata[i].hsnrate;
					}
					this.qtyError = true;
					this.unitprError = true;
					this.searchmodalShow = false;
				}
			}
		},
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * 10
			this.searchproductsdata(2)
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/purchaseOrder/po.component.js